import {createSlice} from '@reduxjs/toolkit';

export const alertHandler = createSlice({
    name: 'aHandler',
    initialState: {
        visibility:  0,
        message: 'Notificaiton Message here',
        msg_short: "error",
        classType: 'error'
    },
    reducers: {

        display: (state, action) => {
          state.visibility === 0 ? state.visibility += 1 : null,
             state.message = action.payload.message,
             state.msg_short = action.payload.msg_short,
             state.classType = action.payload.classType
          },
          close: (state) => {
            state.visibility > 0 ? state.visibility -= 1 : null
            // console.log("closed with visibility of: "+state.visibility)
          },
        //   incrementByAmount: (state, action) => {
        //     state.value += action.payload
        //   },
    },
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = apiPath.actions

export const { close, display } = alertHandler.actions
export default alertHandler.reducer